// extracted by mini-css-extract-plugin
export default {"menuButton":"AssessmentMenu_menuButton__f0Nhp","menuButtonActive":"AssessmentMenu_menuButtonActive__wiF8C"};